import { FaEdit, FaEye, FaTrashAlt } from "react-icons/fa";
import { ROUTES } from "constants/routes-path";
import { PERMISSIONS } from "../../../constants/permission";

export const ProcessGeneralActions = (t, navigate, handleRemove) => [
  {
    label: t("system.actions.details"),
    icon: <FaEye />,
    onClick: ({ original }) => {
      navigate(ROUTES.processesDetailsPath.replace(":id", original.id));
    },
    visible: () => true,
  },
  {
    label: t("system.actions.edit"),
    icon: <FaEdit />,
    onClick: (row) =>
      navigate(ROUTES.processesEditPath.replace(":id", row.original.id)),
    visible: (values) => values.is_editable,
  },
  {
    label: t("system.actions.remove"),
    icon: <FaTrashAlt color="#E53E3E" />,
    permissions: [PERMISSIONS.DELETE_PROCESSES],
    onClick: (row) => handleRemove(row.original.id),
    visible: (values) =>
      values.is_editable &&
      !values.response_process_creation &&
      !values.response_process_result,
  },
];
